import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { StyledGreyInfoBox } from "../../components/commonComponents/StyledComponents/styled";
import { scopedRetailerDisplayName } from "../../api_calls/retailerSelection";
import { ANALYTICS_UNAVAILABLE_CAMPAIGN_NOT_FOUND } from "../../api_calls/campaignRequests";

const noStoresMessageLines = (scopedRetailerName) =>
  scopedRetailerName !== ""
    ? [
        `This campaign does not include any store of ${scopedRetailerName}.`,
        'Select "All Retailers" or a participating retailer to view the report.',
      ]
    : ["This campaign does not include any stores."];

const emptyStateShellSx = {
  flex: 1,
  width: "100%",
  minHeight: "100vh",
  display: "grid",
  placeItems: "center",
  px: 2,
  boxSizing: "border-box",
};

const CampaignAnalyticsEmptyState = ({ reason }) => {
  const scopedRetailerName = scopedRetailerDisplayName();
  const lines = noStoresMessageLines(scopedRetailerName);

  return (
    <Box sx={emptyStateShellSx}>
      <StyledGreyInfoBox
        sx={{
          border: "1px solid #AF3241",
          borderRadius: "12px",
          maxWidth: 560,
          textAlign: "center",
          color: "#AF3241",
        }}
      >
        <Stack spacing={0.5} alignItems="center">
          {lines.map((line) => (
            <Typography key={line} variant="body2" component="p" sx={{ fontWeight: "bold", m: 0 }}>
              {line}
            </Typography>
          ))}
        </Stack>
      </StyledGreyInfoBox>
    </Box>
  );
};

export default CampaignAnalyticsEmptyState;
